export const theme = {
    token: {
        colorPrimary: '#365314', // Custom primary color
        colorPrimaryBorder: '#365314',
        borderRadius: 8,         // Global border radius
        fontSize: 14,            // Base font size
    },
    components: {        
        Switch: {
            handleBg: '#ececec',
            trackHeight: 30,
            trackMinWidth: 64,
            innerMaxMargin: 30,
            handleSize: 26,
        },
        Tabs: {
            horizontalMargin: "0 0 0 20px",
            cardGutter: 4,
            cardBg: 'rgba(255,255,255,0.7)',
            colorBorder: 'rgba(255,255,255,0)',
        },
        Radio: {
            dotSize: 10,
            radioSize: 24,
        },
        Form:{
            verticalLabelPadding: "0 0 6px",
        },        
      },
};
